import { DEVICE_ROLES } from '@/features/core/container';
import { SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import lg from './kone-lift-lg.svg';
import md from './kone-lift-md.svg';
import sm from './kone-lift-sm.svg';
import component from './KoneLiftDevicePanel.vue';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.KONE_LIFT,
  label: 'Kone Aufzug',
  shortLabel: 'Kone Aufzug',
  icons: { sm, md, lg },
  component,
  externalDetailsLink: 'https://koneonline.force.com/koneonline/ccloginportal',
}));
